export const ADD_NEW_TRANSACTION = 'ADD_NEW_TRANSACTION'
export const GET_BALANCE = 'GET_BALANCE'
export const SET_USER_INFO = 'SET_USER_INFO'
export const REMOVE_TRANSACTIONS = 'REMOVE_TRANSACTIONS'
export const SET_TRANSACTIONS = 'SET_TRANSACTIONS'